
import { Button } from "@/components/ui/button";
import { Mail, Github } from "lucide-react";
import React from "react";

interface SocialAuthButtonsProps {
  onGoogle: () => void;
  onGitHub: () => void;
  loading: boolean;
}

const SocialAuthButtons: React.FC<SocialAuthButtonsProps> = ({
  onGoogle,
  onGitHub,
  loading,
}) => (
  <div className="space-y-2">
    <Button
      type="button"
      variant="outline"
      className="w-full"
      onClick={onGoogle}
      disabled={loading}
    >
      <Mail className="mr-2 h-4 w-4" />
      Continue with Google
    </Button>
    <Button
      type="button"
      variant="outline"
      className="w-full"
      onClick={onGitHub}
      disabled={loading}
    >
      <Github className="mr-2 h-4 w-4" />
      Continue with GitHub
    </Button>
  </div>
);

export default SocialAuthButtons;
